import { Injectable } from '@angular/core';

@Injectable()
export class ApiConfig {
  dataApiBaseUrl: string;
  timelineApiBaseUrl: string;
  workflowApiBaseUrl: string;
  notificationApiBaseUrl: string;
  commentsApiBaseUrl: string;
  reactionApiBaseUrl: string;
  functionsApiBaseUrl: string;
  logsApiBaseUrl: string;
qrCodeApiBaseUrl: string;
  set(config: Partial<ApiConfig>): void {
    Object.assign(this, config);
  }
}
